'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_GAS_PRICE_MAX = exports.BACKUP_TOKEN_AUTH_GAS_PRICE = exports.DEFAULT_ETH_DECIMALS = exports.MAX_TOKEN_AUTHORIZATION_AMOUNT_WEI = exports.ZERO_ADDRESS = exports.DYNAMIC_TOKEN_CONTRACT_ABI = exports.TransactionStatusEnum = exports.NETWORK_NAMES = exports.COINMARKET_CAP_ENDPOINT = exports.ETH_GAS_PRICE_ENDPOINT = exports.CURRENCY_CODES = exports.LEDGER_TIMEOUT = exports.LONG_TIMEOUT = exports.PREFLIGHT_TIMEOUT_MS = exports.ERROR_REPORING_THROTTLE_TIMEOUT = exports.NOTIFICATION_DEFAULT_CLOSE_TIME = exports.RETRY_WAIT_INTERVAL = exports.LOADING_CHECK_FREQUENCY = exports.PULL_TIME = undefined;

var _dynamicTokenContract = require('./abi/dynamicTokenContract.json');

var dynamicTokenContractConfig = _interopRequireWildcard(_dynamicTokenContract);

var _safeToBn = require('./utilities/safeToBn');

var _safeToBn2 = _interopRequireDefault(_safeToBn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var PULL_TIME = exports.PULL_TIME = 500;
var LOADING_CHECK_FREQUENCY = exports.LOADING_CHECK_FREQUENCY = 750;
var RETRY_WAIT_INTERVAL = exports.RETRY_WAIT_INTERVAL = 5 * 1000;
var NOTIFICATION_DEFAULT_CLOSE_TIME = exports.NOTIFICATION_DEFAULT_CLOSE_TIME = 4000;
var ERROR_REPORING_THROTTLE_TIMEOUT = exports.ERROR_REPORING_THROTTLE_TIMEOUT = 5000;
var PREFLIGHT_TIMEOUT_MS = exports.PREFLIGHT_TIMEOUT_MS = 2000;
// arbitrary long (as if it was disabled)
var LONG_TIMEOUT = exports.LONG_TIMEOUT = 10000000;

// this is set to 29s to be just shy of the library's internal timeout of 30s
var LEDGER_TIMEOUT = exports.LEDGER_TIMEOUT = 29000;

var CURRENCY_CODES = exports.CURRENCY_CODES = ['usd', 'aud', 'cad', 'cny', 'eur', 'gbp', 'jpy'];

var ETH_GAS_PRICE_ENDPOINT = exports.ETH_GAS_PRICE_ENDPOINT = 'https://ethgasstation.info/json/ethgasAPI.json';
var COINMARKET_CAP_ENDPOINT = exports.COINMARKET_CAP_ENDPOINT = 'https://api.coinmarketcap.com/v1/ticker/ethereum/';

// Mapping network IDs to names from https://github.com/ethereum/EIPs/blob/master/EIPS/eip-155.md.
var NETWORK_NAMES = exports.NETWORK_NAMES = Object.freeze({
  1: 'Ethereum Mainnet',
  2: 'Expanse Mainnet',
  3: 'Ropsten',
  4: 'Rinkeby',
  30: 'Rootstock Mainnet',
  31: 'Rootstock testnet',
  42: 'Kovan',
  61: 'Ethereum Classic Mainnet',
  62: 'Ethereum Classic testnet',
  1337: 'Geth Private chain',
  default: 'Unknown'
});

var TransactionStatusEnum = exports.TransactionStatusEnum = Object.freeze({
  pending: -1,
  failed: 0,
  succeeded: 1
});

var DYNAMIC_TOKEN_CONTRACT_ABI = exports.DYNAMIC_TOKEN_CONTRACT_ABI = dynamicTokenContractConfig.ABI;

var ZERO_ADDRESS = exports.ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

var MAX_TOKEN_AUTHORIZATION_AMOUNT_WEI = exports.MAX_TOKEN_AUTHORIZATION_AMOUNT_WEI = (0, _safeToBn2.default)('115792089237316195423570985008687907853269984665640564039457584007913129639935');

var DEFAULT_ETH_DECIMALS = exports.DEFAULT_ETH_DECIMALS = 4;

var BACKUP_TOKEN_AUTH_GAS_PRICE = exports.BACKUP_TOKEN_AUTH_GAS_PRICE = '5000000000';

var DEFAULT_GAS_PRICE_MAX = exports.DEFAULT_GAS_PRICE_MAX = 50;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/constants.js
// module id = 20
// module chunks = 0